import { useEffect, useState } from "react";

const THRESHOLD = 140;

export default function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const check = () => setOpen(window.innerHeight - vv.height > THRESHOLD);
    vv.addEventListener("resize", check);
    vv.addEventListener("scroll", check);
    check();
    return () => {
      vv.removeEventListener("resize", check);
      vv.removeEventListener("scroll", check);
    };
  }, []);
  return open;
}
